var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02191 0.966004C6.09439 0.965979 6.16616 0.980286 6.23309 1.00809C6.30002 1.03589 6.3608 1.07664 6.41193 1.12801L11.3679 6.06C11.4712 6.16349 11.5293 6.30376 11.5293 6.45C11.5293 6.59624 11.4712 6.7365 11.3679 6.84C11.2644 6.94332 11.1241 7.00136 10.9779 7.00136C10.8317 7.00136 10.6914 6.94332 10.588 6.84L6.02191 2.298L1.39191 6.84C1.28841 6.94332 1.14819 7.00136 1.00195 7.00136C0.855712 7.00136 0.715432 6.94332 0.611938 6.84C0.508615 6.7365 0.450562 6.59624 0.450561 6.45C0.450561 6.30376 0.508615 6.16349 0.611938 6.06L5.6319 1.12801C5.68306 1.07668 5.74387 1.03596 5.81079 1.00816C5.87771 0.980366 5.94945 0.966034 6.02191 0.966004Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.d4c06ad9af40ba210e6bb51c639e9295.svg";
export { ForwardRef as ReactComponent };